module.exports = __webpack_public_path__ + "static/media/400419_02.5286a601.png";